import { css } from 'styled-components';
import {
  colors,
  duration,
  ease,
  elevation,
  isDefaultThemeMode,
  accessibilityBorder,
  accessibilityHoverInvertDark,
} from 'core/theme';
import ButtonText from './ButtonText';

const applyBoxShadow = (props) => {
  if (isDefaultThemeMode(props) && !props.disabled) {
    return css`
      box-shadow: ${elevation.Z0};
      transition: box-shadow ${duration.fast} ${ease.standard};
      will-change: box-shadow;

      &:hover {
        box-shadow: ${elevation.Z2};
      }

      &:active {
        box-shadow: ${elevation.Z8};
      }
    `;
  }
}

const ButtonStandard = ButtonText.extend`
  background-color: ${props => props.disabled ? colors.highlight : colors.accent};
  color: ${props => props.disabled ? colors.disabled : colors.background};
  ${applyBoxShadow};

  ${({disabled, ...rest}) => !disabled && css`
    &:hover {
      background-color: ${props => colors.accent(props, 'light')};
      color: ${colors.background};
    }

    &:active {
      background-color: ${props => colors.accent(props, 'dark')};
      color: ${colors.background};
    }
  `}

  ${accessibilityBorder};
  ${accessibilityHoverInvertDark};
`;

export default ButtonStandard;



// WEBPACK FOOTER //
// ./src/elements/Button/styled/ButtonStandard.js